import { Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import React from 'react'
import './search-box.scss'

interface SearchTipBoxProps {
    keyWord: string
    onClose: () => void
    style?: React.CSSProperties
}

const SearchTipBox: React.FC<SearchTipBoxProps> = props => {
    const getCls = useBemClass('search-tip-box')

    return (
        <Row className={getCls('searchBox')} style={props.style}>
            <div>
                以下是
                <span className="them-color" data-padding-h-8>
                    {props.keyWord}
                </span>
                的搜索结果
            </div>
            <div
                className={getCls('delete')}
                onClick={() => {
                    props.onClose()
                }}
            >
                <i data-cursor-pointer className="iconfont icon6guanbi-20" />
            </div>
        </Row>
    )
}

export default SearchTipBox
